import React from 'react';
import { circleThemes, cx } from '../theme';

export default function CircleTabNav({ circles, activeCircle, onChange }) {
  return (
    <div className="rounded-2xl border border-app-border bg-white p-2 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <div className="flex gap-2 overflow-x-auto" role="tablist" aria-label="COO circle tabs">
        {circles.map((circle) => {
          const isActive = circle.id === activeCircle;
          return (
            <button
              key={circle.id}
              id={`circle-tab-${circle.id}`}
              data-coo="circle-tab"
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={`circle-panel-${circle.id}`}
              onClick={() => onChange(circle.id)}
              className={cx(
                'min-w-[220px] rounded-xl border px-4 py-3 text-left transition-[background-color,border-color,box-shadow,color] duration-150',
                isActive
                  ? circleThemes[circle.id].tabActive
                  : 'border-transparent bg-white text-slate-500 hover:border-app-border hover:bg-slate-50 hover:text-slate-700',
              )}
            >
              <span className="mb-1 flex items-center gap-2">
                <span className={cx('h-2 w-2 rounded-full', circleThemes[circle.id].accentDot)} />
                <span
                  data-coo="tab-label"
                  className={cx('block text-[12px] font-semibold uppercase tracking-[0.08em]', isActive ? circleThemes[circle.id].tabText : 'text-slate-500')}
                >
                  {circle.tabLabel}
                </span>
              </span>
              <span data-coo="tab-summary" className="block text-[10px] leading-relaxed text-slate-500">
                {circle.tabSummary}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
